export class NotifyUsersInput{
  busType : any;
  usersType : any;
  usersSubType : any;
  apprType : any;
  includeRfsps : any;
  emailSubject : any;
  banner: any;
  emailBody : any;
  attachments : any[];
}